<template>
  <div class="d-flex justify-content-between align-items-center">
    <i class="fas fa-edit link" @click="toggleModal"></i>
    <call-note-modal
      v-if="open"
      :call-id="callId"
      :note-text="noteText"
      :add-note-path="addNotePath"
      :remove-note-path="removeNotePath"
      @hide-modal="toggleModal"
    ></call-note-modal>
  </div>
</template>

<script>
import CallNoteModal from "./CallNoteModal.vue";
export default {
  components: {
    CallNoteModal,
  },
  props: {
    callId: {
      type: Number,
      default: null,
    },
    noteText: {
      type: String,
      default: null,
    },
    noteToolTip: {
      type: String,
      default: null,
    },
    addNotePath: {
      type: String,
      default: null,
    },
    removeNotePath: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggleModal() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped></style>
